/**
 * @fileoverview ESM view of the single USD display formatter.
 * @package @puffin-core/money
 * @module lib/esm/formatUsd
 * @copyright ParcelPuffin 2026
 *
 * **There is no logic in this file.** The implementation lives once, in CJS, at
 * `../formatUsd.js` — see that file for why this package exists, why it is not part of
 * `@puffin-core/page-shell`, and why CJS is the source direction (the API tier renders
 * money into outbound customer email and its report builders, and cannot `import`).
 *
 * ## Why a destructured DEFAULT import and not `export { x } from …`
 *
 * `export { formatUsd } from '../formatUsd.js'` is a STATIC named import, and bundlers
 * cannot always see through a CJS `module.exports` to satisfy one — `@puffin-tooling/esm-build`'s
 * generator documents this exact trap (it is why `route-match`'s mirror was hand-written).
 * Destructuring a default import is a RUNTIME read, so it works wherever CJS interop
 * works, which is the form that generator emits for all 21 generated packages.
 */

import money from '../formatUsd.js';

export const {
  formatUsd,
  formatUsdOrAbsent,
  readableAmount,
  ABSENT_AMOUNT,
  formatUsdWhole,
  formatUsdWholeOrAbsent,
  formatUsdFromCents,
  formatCents,
  formatCentsFromUsd,
  INVARIANT_REPORT_LOCALE,
} = money;

export default formatUsd;
